import authRoute from "app/scenes/Auth/auth.routes"; 
import salespageRoute from "app/scenes/SalesPage/salespage.routes";
import masterRoutes from 'app/shared/MasterLayout/master.routes';
import LandingPage from "app/scenes/SalesPage/LandingPage";
import path from "path";
import AboutUsPage from "app/scenes/SalesPage/AboutUsPage";
const childRoutes = [authRoute, salespageRoute, masterRoutes]
const routeConfig = [
    ...childRoutes,
    {
      path: "*",
      element: <LandingPage />,
      strict: true,
    },
    ...childRoutes,
    {
      path: "/aboutus",
      element: <AboutUsPage />,
      strict: true,
    },
];


export default routeConfig; 
